// Server-only exports for React Server Components
export * from './preload/pdp/product-collection-preload';
